import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';

import { Typography } from '@mui/material';

import {
	StyledColorPickerColorBox,
	StyledColorPickerColorInput,
	StyledColorPickerColorWrap,
	StyledColorPickerWrap,
} from './styled';

interface PropsType {
	colors: string[] | string;
	onChange: (string: string | string[]) => void;
}

function ColorPicker({ colors, onChange }: PropsType) {
	const colorsArray = Array.isArray(colors) ? colors : [colors];
	const [currentColorIndex, setCurrentColorIndex] = useState(0);

	const handleColorChange = (color: string) => {
		if (Array.isArray(colors)) {
			const newColorsArray = [...colorsArray];
			newColorsArray[currentColorIndex] = color;
			onChange(newColorsArray);
		} else onChange(color);
	};

	const currentColor = colorsArray[currentColorIndex];

	return (
		<StyledColorPickerWrap>
			<HexColorPicker color={currentColor} onChange={handleColorChange} />
			{colorsArray.map((color, index) => (
				<StyledColorPickerColorWrap
					onClick={() => setCurrentColorIndex(index)}
					sx={color === currentColor && { background: `${color}50` }}
					key={color}
				>
					<StyledColorPickerColorBox sx={{ background: color }} />
					<Typography variant="subtitle1">Hex</Typography>
					<StyledColorPickerColorInput
						value={color}
						onChange={(event) => handleColorChange(event.target.value)}
						sx={{
							border: color === currentColor ? '1px solid #E5E8E8' : `1px solid ${color}`,
						}}
					/>
				</StyledColorPickerColorWrap>
			))}
		</StyledColorPickerWrap>
	);
}

export default ColorPicker;
